<form [formGroup]="form">
  <div class="form-field" *ngFor="let field of fields" [ngSwitch]="field.type">
    <div *ngSwitchCase="FIELD_TYPES.email" class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <input type="email"
               id="{{generateFieldId | thunk: field}}"
               [formControlName]="field.name"
               required="{{field.required}}"
               class="form-control"
               [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
          <ng-container *ngIf="form.controls[field.name].errors?.email">{{formErrors.email}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.radioGroup" class="form-group">
      <div class="form-label" [class.required]="field.required">
        {{field.label}}
      </div>
      <div class="input-with-error">
        <cm-radio-group [formControlName]="field.name"
                        [options]="field.options"
                        [required]="field.required"
                        [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        </cm-radio-group>
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.checkbox" class="form-group">
      <div class="input-with-error single-checkbox">
        <cm-checkbox [formControlName]="field.name" [required]="field.required">{{field.label}}</cm-checkbox>
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.checkboxGroup" class="form-group">
      <div class="form-label" [class.required]="field.required">
        {{field.label}}
      </div>
      <div class="input-with-error">
        <cm-checkbox-group [formControlName]="field.name"
                           [options]="field.options"
                           [required]="field.required"
                           [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        </cm-checkbox-group>
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.select" class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <cm-select class="form-input" id="{{generateFieldId | thunk: field}}" [formControlName]="field.name"
                   [options]="field.options" [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        </cm-select>
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.number" class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <input id="{{generateFieldId | thunk: field}}"
               type="number"
               [formControlName]="field.name"
               class="form-control"
               [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
          <ng-container *ngIf="form.controls[field.name].errors?.positiveNumber">{{formErrors.positiveNumber}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.date" class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <cm-datepicker id="{{generateFieldId | thunk: field}}" [formControlName]="field.name"
                       [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        </cm-datepicker>
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.text" class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <input id="{{generateFieldId | thunk: field}}"
               [formControlName]="field.name"
               class="form-control"
               [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
          <ng-container *ngIf="form.controls[field.name].errors?.phone">{{formErrors.phone}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.textarea" class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <textarea id="{{generateFieldId | thunk: field}}"
               [formControlName]="field.name"
               class="form-control"
                  [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors"></textarea>
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.typeahead" class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <cm-typeahead id="{{generateFieldId | thunk: field}}"
                      class="form-input"
                      [formControlName]="field.name"
                      [request$]="field.request$"
                      [formatter]="field.formatter"
                      [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors"></cm-typeahead>
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="FIELD_TYPES.location" class="form-group">
      <cm-location [formControlName]="field.name" [showErrors]="showErrors"></cm-location>
      <div class="invalid-feedback" [class.show]="showErrors">
        <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
      </div>
    </div>

    <div *ngSwitchDefault class="form-group">
      <label for="{{generateFieldId | thunk: field}}" class="form-label" [class.required]="field.required">
        {{field.label}}
      </label>
      <div class="input-with-error">
        <input id="{{generateFieldId | thunk: field}}"
               [formControlName]="field.name"
               class="form-control"
               [class.is-invalid]="showError | thunk: form.controls[field.name].errors: showErrors">
        <div class="invalid-feedback" [class.show]="showErrors">
          <ng-container *ngIf="form.controls[field.name].errors?.required">{{formErrors.required}}</ng-container>
        </div>
      </div>
    </div>
  </div>
</form>
